/** @jsxImportSource @emotion/react */
import {
  Typography,
  UtilityButton,
  useTheme,
  useFormatCurrency,
} from '@quickbit/qb-design-system';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useMount } from 'react-use';
import { Status } from 'components';
import { useMixpanel } from 'context';
import { OnrampLayout } from 'onramp-pages/components';
import { useOnrampData } from 'onramp-pages/context';
import { inIFrame } from 'utils';

export const Success = () => {
  const { formatMessage } = useIntl();
  const { spacing } = useTheme();
  const formatCurrency = useFormatCurrency();
  const { cryptoAmount, redirectUrl, merchantName, fiatAmount } =
    useOnrampData();
  const { mixpanelTrackEvent } = useMixpanel({
    Product: 'TopUp',
    Page: 'Success',
    onMountProps: {
      description: 'User successfully paid for the order.',
    },
  });

  useMount(() => {
    mixpanelTrackEvent('Send completed', {
      description: 'User successfully paid for the order.',
    });
  });

  useEffect(() => {
    if (redirectUrl) {
      mixpanelTrackEvent('Redirecting to success page');
      setTimeout(() => {
        const windowLocation = inIFrame()
          ? window.parent.location
          : window.location;
        windowLocation.replace(redirectUrl);
      }, 1000);
    }
  }, [redirectUrl, mixpanelTrackEvent]);

  return (
    <OnrampLayout
      topChildren={
        <div>
          <Status
            heading={formatMessage({
              id: 'page.send.processing.success.title',
            })}
            subHeading={
              fiatAmount && cryptoAmount
                ? formatMessage(
                    {
                      id: 'page.onramp.success.body',
                    },
                    {
                      amount: formatCurrency(fiatAmount),
                      cryptoAmount: formatCurrency(cryptoAmount),
                      merchantName,
                    }
                  )
                : ''
            }
            imageProps={{
              name: 'transferSuccess',
              size: spacing.xxl,
              showPlaceholder: false,
            }}
          />
          {redirectUrl && (
            <div
              css={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                marginTop: spacing.xs,
                gap: spacing.xxxs,
              }}
            >
              <Typography>
                {formatMessage({
                  id: 'page.onramp.success.redirect',
                })}
              </Typography>
              <a href={redirectUrl}>
                <UtilityButton
                  text={formatMessage(
                    {
                      id: 'page.onramp.success.button',
                    },
                    { merchantName: merchantName ?? '' }
                  )}
                />
              </a>
            </div>
          )}
        </div>
      }
    />
  );
};

export default Success;
